import React from 'react';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';
import { Title } from '~/domains/design-system/Title';
import { Text } from '~/domains/design-system/Text';
import dt from '~/testing';

import useStyles from './FullScreenMessage.styles';

type FullScreenMessageProps = {
  className?: string;
  title?: JSX.Element | string;
  subtitle?: JSX.Element | string;
  icon?: JSX.Element;
  iconBackground?: string;
  actions?: JSX.Element;
};

export function FullScreenMessage({
  className,
  title,
  subtitle,
  icon,
  iconBackground,
  actions,
}: FullScreenMessageProps) {
  const isMobile = useIsMobile();
  const { classes, theme, cx } = useStyles({ isMobile, iconBackground });

  return (
    <div className={cx(classes.container, className)}>
      {icon && <div className={classes.iconWrapper}>{icon}</div>}
      <div className={classes.content}>
        {title && (
          <Title
            data-test-id={dt.common.components.fullScreenMessage.title}
            variant="headline-xxl"
            maw="500px"
            color={theme.colors.gray2[6]}
          >
            {title}
          </Title>
        )}
        {subtitle && (
          <Text
            data-test-id={dt.common.components.fullScreenMessage.text}
            variant="body-large"
            color={theme.colors.gray2[6]}
            maw="400px"
          >
            {subtitle}
          </Text>
        )}
      </div>

      {actions}
    </div>
  );
}
